import { useSelector } from 'react-redux';
import CustomTabs from '../../../../../components/custom-tabs/CustomTabs';
import DownlaodOutboundForm from './DownloadForms/DownlaodOutboundForm';
import DownloadBatchReleaseCertificate from './DownloadForms/DownloadBatchReleaseCertificate';
import DownloadCARTForm from './DownloadForms/DownloadCARTForm';
import DownloadCOAForm from './DownloadForms/DownloadCOAForm';
import DownloadInboundForm from "./DownloadForms/DownloadInboundForm"
import DownloadLabelPrint from "./DownloadForms/DownloadLabelPrint"
import DownloadManufacturePrint from "./DownloadForms/DownloadManufacturePrint"

const TabsDetail = ({fetchTimeLineApi,patientMedicalInfo, patientData, patientInfo, qrCodeDataUrl}) => {
const LoginData = useSelector((state) => state.loginData);
const role = LoginData?.role_slug;
const isInBoundPrint = ["superadmin","editor","project-manager", "logistics-management", "warehouse", "quality-check"]
  .includes(role);
const isOutBoundPrint = ["superadmin","editor", "project-manager","logistics-management","quality-associate"].includes(role);
const isCOAPrint = ["superadmin","quality-associate"].includes(role);
const isBatchPrint = ["superadmin","quality-associate"].includes(role);
const isCARTPrint = ["superadmin","manufacture", "manufacture-lead"].includes(role);
const isLabelPrint = ["logistics-management"].includes(role);
const isManufacturePrint = ['manufacture'].includes(role);

const phasesData = [
    ...(isCARTPrint ? [{
      id: 1,
      title: "CAR-T Manufacturing",
      component: <DownloadCARTForm patientData={patientData} patientInfo={patientInfo} />
    }] : []),
    ...(isBatchPrint ? [{
      id: 2,
      title: "Batch Release certificate",
      component: <DownloadBatchReleaseCertificate patientData={patientData} patientInfo={patientInfo} />
    }] : []),
    ...(isCOAPrint ? [{
      id: 3,
      title: "Certificate of Analysis",
      component: <DownloadCOAForm patientData={patientData} patientInfo={patientInfo} />
    }] : []),
    ...(isOutBoundPrint ? [{
      id: 4,
      title: "Out-Bound Form",
      component: <DownlaodOutboundForm patientData={patientData} />
    }] : []),
 ...(isManufacturePrint
      ? [
        {
          id: 5,
          title: "Manufacturer Print",
          component: <DownloadManufacturePrint patientMedicalInfo={patientMedicalInfo} patientData={patientData} patientInfo={patientInfo} qrCodeDataUrl={qrCodeDataUrl} />
        }
      ]
      : []),
    ...(isInBoundPrint
      ? [
        {
          id: 6,
          title: "In-Bound Form",
          component: <DownloadInboundForm patientData={patientData} />
        }
      ]
      : []),
       ...(isLabelPrint
      ? [
        {
          id: 7,
          title: "Label Print",
          component: <DownloadLabelPrint fetchTimeLineApi={fetchTimeLineApi} patientMedicalInfo={patientMedicalInfo} patientData={patientData} patientInfo={patientInfo} qrCodeDataUrl={qrCodeDataUrl} />
        }
      ]
      : []),
  ];

const activeTabId = phasesData?.[0]?.id;

  return (
    <CustomTabs
      phases={phasesData}
      activePhaseId={activeTabId} //@info default first one open
      onPhaseChange={(id)=>{id}}
      isTabTitleOnly={true}
      renderPhaseContent={(phase) => (
        <div className="p-4">
          {phase.component}
        </div>
      )}
    />
  )
}

export default TabsDetail